/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R4_AddressInputs */

const tr_kvkkbasvuru_s2_r4_address = /** @type {(inputs: Kvkkbasvuru_S2_R4_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yukarıdaki kanallardan biri`)
};

const en_kvkkbasvuru_s2_r4_address = /** @type {(inputs: Kvkkbasvuru_S2_R4_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One of the channels above`)
};

const de_kvkkbasvuru_s2_r4_address = /** @type {(inputs: Kvkkbasvuru_S2_R4_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einer der oben genannten Wege`)
};

const ru_kvkkbasvuru_s2_r4_address = /** @type {(inputs: Kvkkbasvuru_S2_R4_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Один из указанных выше каналов`)
};

/**
* | output |
* | --- |
* | "One of the channels above" |
*
* @param {Kvkkbasvuru_S2_R4_AddressInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r4_address = /** @type {((inputs?: Kvkkbasvuru_S2_R4_AddressInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R4_AddressInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r4_address(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r4_address(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r4_address(inputs)
	return tr_kvkkbasvuru_s2_r4_address(inputs)
});